import { Component, Input } from '@angular/core';

@Component({
    selector: 'tyt-full-live-schedule',
    standalone: false,
    template: `
        <tyt-live-schedule
            [numberOfDays]="7"
            [maximumEvents]="9999"
            [mode]="mode"
            [isFullLiveSchedule]="isFullLiveSchedule"
        />
    `
})
export class FullLiveScheduleComponent {

    @Input() mode: 'events' | 'days' = 'days';
    isFullLiveSchedule = true;
}
